export const MAIN_CONTENT_ELEMENT_ID = "main-content";

export const MODAL_STYLE = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50vw",
  bgcolor: "background.paper",
  p: 4,
};
